var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrafficJam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.66669 682.66669",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2440"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2450"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2448",
    fill: "#ffffff",
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2442",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2446",
    clipPath: "url(#clipPath2450)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2452",
    transform: "translate(205.1221,103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -57.449 c -6.6,0 -12.775,-3.256 -16.504,-8.702 L -111.122,-63 h 167 L 16.192,-8.261 C 12.43,-3.071 6.409,0 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2454",
    fill: "#ffffff",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2456",
    transform: "translate(314.3984,168.4619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -37.811,68.273 C -48.189,86.841 -69.163,98.538 -92.08,98.538 h -92.67 c -22.9,0 -43.862,-11.68 -54.248,-30.225 L -276.566,0.601",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2458",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2460",
    transform: "translate(279.1187,44.8438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -24.844 h 52.881 v 30 h -312 v 78.538 c 0,29.527 26.34,53.462 58.831,53.462 H -5.949 c 32.491,0 58.83,-23.473 58.83,-53 v -79",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2462",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2464",
    transform: "translate(72.8813,46.6455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -26.646 H -52.881 V 75.566",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2466",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2468",
    transform: "translate(285,115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-11.046 -8.954,-20 -20,-20 -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 C -8.954,20 0,11.046 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2470",
    fill: "#ffffff",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2472",
    transform: "translate(106,115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-11.046 -8.954,-20 -20,-20 -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 C -8.954,20 0,11.046 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2474",
    fill: "#ffffff",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2476",
    transform: "translate(303,479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -10.945,8.805 -25.554,13 -40.681,13 h -92.671 c -22.899,0 -43.861,-11.68 -54.247,-30.226 l -37.569,-67.712",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2478",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2480",
    transform: "translate(60,321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 32.538 C 0,62.064 26.339,86 58.831,86 H 108",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2482",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2484",
    transform: "translate(146,340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-11.046 -8.954,-20 -20,-20 -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 C -8.954,20 0,11.046 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2486",
    fill: "#ffffff",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2488",
    transform: "translate(445,252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-11.046 -8.954,-20 -20,-20 -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 C -8.954,20 0,11.046 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2490",
    fill: "#ffffff",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2492",
    transform: "translate(238.6152,341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 14.236,26.002 C 21.039,38.15 35.482,46 51.033,46 h 92.671 c 15.563,0 30.012,-7.859 36.772,-19.954 L 194.347,1 H 52.383 C 41.356,1 32.41,-7.926 32.385,-18.953 32.359,-30.017 41.322,-39 52.386,-39 h 142.168 c 21.411,0 38.831,-14.804 38.831,-33 0,-11.122 9.077,-20.123 20.227,-19.999 11.039,0.123 19.849,9.459 19.771,20.499 -0.127,17.949 -7.104,34.751 -19.758,47.946 -0.119,0.235 -0.217,0.474 -0.346,0.705 L 215.43,45.493 C 201.465,70.479 173.981,86 143.704,86 H 51.033 C 20.782,86 -6.691,70.499 -20.703,45.478 L -36.615,15.571 C -43.979,2.3 -35.062,-14 -19.885,-14 -10.615,-14 -5.615,-9 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2494",
    fill: "#ffffff",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2496",
    transform: "translate(503.1885,202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -107.188 c -11.046,0 -20,-8.954 -20,-20 0,-11.046 8.954,-20 20,-20 h 23.118 v -10 c 0,-11.046 8.954,-20 20,-20 h 52.882 c 11.045,0 20,8.954 20,20 V -8.812 C 8.812,-3.945 4.866,0 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path2498",
    fill: "#ffffff",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2500",
    transform: "translate(492,271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -99",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2502",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficJam);
export default __webpack_public_path__ + "static/media/trafficJam.e72dfb1a9dfea15e5c92c9c4bceff437.svg";
export { ForwardRef as ReactComponent };